import React, { useState, useEffect } from "react";
// componentes
import {
  Table,
  Card,
  CardBody,
  CardTitle,
  Button,
  Collapse,
  Row,
  Spinner,
} from "reactstrap";
import DeleteButton from "../../../components/Buttons/DeleteButton";
import ModalNewMenu from "./ModalNewMenu";
import ModalEdidMenu from "./ModalEditMenu";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";
// posição da tabela
import ReactDragListView from "react-drag-listview";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
// redux
import { connect } from "react-redux";
// rotas
import { useLocation } from "react-router-dom";
// service
import {
  getMenus,
  deleteButtonMenu,
  orderButtonMenu,
} from "../../../utils/services/menus";

function Menu(props) {
  const location = useLocation();

  //pesquisa
  const [search, setSearch] = useState("");
  //modais
  const [modalNewMenu, setModalNewMenu] = useState(false);
  const [modalEditMenu, setModalEditMenu] = useState(false);
  //deletar evento
  const [confirmAlert, setConfirmAlert] = useState(false);
  const [successDlg, setSuccessDlg] = useState(false);
  const [dynamicTitle, setDynamicTitle] = useState("");
  const [dynamicDescription, setDynamicDescription] = useState("");
  const [isDeleteError, setIsDeleteError] = useState(false);
  const [deleteButtonData, setDeleteButtonData] = useState(null);

  //paginação (sem paginação de verdade: sempre mostra até 200 itens)
  const currentIndex = 0;
  //state dos menus
  const [menus, setMenus] = useState([]);
  //state de editar botão
  const [editMenu, setEditMenu] = useState();
  //state id botão
  const [idButton, setIdButton] = useState();
  const [isDirty, setIsDirty] = useState(false);
  // collapse
  const [isOpen, setIsOpen] = useState(false);
  // loading
  const [loading, setLoading] = useState(false);
  // reordenando (drag ou após exclusão)
  const [isReordering, setIsReordering] = useState(false);

  // abre/fecha o modal de criar botão
  function toggleNewMenu() {
    setModalNewMenu(!modalNewMenu);
  }

  // abre/fecha o modal de editar botão
  function toggleEditMenu() {
    setModalEditMenu(!modalEditMenu);
  }

  // busca os botões de menu do evento
  const getAllMenus = async () => {
    setLoading(true);
    try {
      const formData = await getMenus(
        props.state.global_user_data.data.token,
        location.state.idEvent,
      );
      if (formData.findOneMenuData) {
        setIdButton(formData.findOneMenuData.id);
        setMenus(
          formData.findOneMenuData.buttons.sort((a, b) => a.order - b.order),
        );
      }
    } catch (error) {
      console.error("Erro ao buscar os menus:", error);
      toast.error("Erro ao buscar os menus.");
    } finally {
      setLoading(false);
    }
  };

  // envia a nova ordem dos botões para a api
  async function saveButtonsOrder(buttons) {
    setIsReordering(true);
    try {
      await orderButtonMenu(
        { menuId: idButton, buttons },
        props.state.global_user_data.data.token,
      );
    } catch (error) {
      console.error("Erro ao reordenar os botões:", error);
      toast.error("Erro ao reordenar os botões.");
    } finally {
      setIsReordering(false);
    }
  }

  // exclui o botão selecionado e reordena os demais
  const deleteButton = async () => {
    try {
      const eventData = await deleteButtonMenu(
        deleteButtonData.id,
        props.state.global_user_data.data.token,
      );

      if (eventData.message === "BUTTON_DELETED") {
        deleteConfirm();
        const items = [
          ...menus.filter((e) => e.id !== eventData.disableUserData.id),
        ];
        const data = items.map((e, i) => {
          return { ...e, order: ++i };
        });

        setMenus(data);
        saveButtonsOrder(data);
      } else {
        setConfirmAlert(false);
        setDynamicTitle("Erro");
        setDynamicDescription("Erro ao deletar o botão.");
        setIsDeleteError(true);
        setSuccessDlg(true);
      }
    } catch (error) {
      console.error("Erro ao deletar o botão:", error);
      setConfirmAlert(false);
      setDynamicTitle("Erro");
      setDynamicDescription("Erro ao deletar o botão.");
      setIsDeleteError(true);
      setSuccessDlg(true);
    }
  };

  // fecha a confirmação e mostra o alerta de sucesso da exclusão
  function deleteConfirm() {
    setConfirmAlert(false);
    setDynamicTitle("Sucesso");
    setDynamicDescription("Botão deletado com sucesso");
    setIsDeleteError(false);
    setSuccessDlg(true);
  }

  useEffect(() => {
    getAllMenus();
  }, []);

  // reordena os botões via drag and drop
  const onDragEnd = (fromIndex, toIndex) => {
    if (toIndex < 0) return;

    const items = [...menus];
    const item = items.splice(fromIndex, 1)[0];
    items.splice(toIndex, 0, item);
    setIsDirty(true);
    setMenus(items);
    const data = items.map((e, i) => {
      return { ...e, order: ++i };
    });

    saveButtonsOrder(data);
  };
  return (
    <div>
      {modalNewMenu && (
        <ModalNewMenu
          isOpen={modalNewMenu}
          toggle={toggleNewMenu}
          getAllMenus={getAllMenus}
          idButton={idButton}
          menus={menus}
          idEvent={location.state.idEvent}
        />
      )}
      {modalEditMenu && (
        <ModalEdidMenu
          isOpen={modalEditMenu}
          toggle={toggleEditMenu}
          editMenu={editMenu}
          getAllMenus={getAllMenus}
          idButton={idButton}
          menus={menus}
          idEvent={location.state.idEvent}
        />
      )}

      {confirmAlert ? (
        <SweetAlert
          title="Deseja deletar esse botão?"
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            deleteButton();
          }}
          onCancel={() => setConfirmAlert(false)}
        >
          Você não poderá reverter essa ação!
        </SweetAlert>
      ) : null}

      {successDlg ? (
        <SweetAlert
          success={!isDeleteError}
          error={isDeleteError}
          title={dynamicTitle}
          onConfirm={() => {
            setSuccessDlg(false);
          }}
        >
          {dynamicDescription}
        </SweetAlert>
      ) : null}

      <Card>
        <CardBody>
          <CardTitle>Menu do App</CardTitle>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>
            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>

              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              />
              <Collapse isOpen={isOpen}>
                <ActionButtonRounded
                  title="Criar Botão"
                  onClick={() => setModalNewMenu(true)}
                  type="mobile"
                />
              </Collapse>
            </div>
            <div className="header-btns-container">
              <ActionButtonRounded
                title="Criar Botão"
                onClick={() => setModalNewMenu(true)}
              />
            </div>
          </div>

          <div className="table-responsive">
            <ReactDragListView onDragEnd={onDragEnd}>
              <Table className="table mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Ordem</th>
                    <th>Nome</th>
                    <th>Nome de Exibição</th>
                    <th>Visível</th>
                    <th>Padrão</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <LoadingSkelentonTable lines={10} cols={6} />
                  ) : (
                    menus
                      .filter(
                        (e) =>
                          e.description
                            .toLocaleLowerCase()
                            .indexOf(search.toLocaleLowerCase()) > -1,
                      )
                      .slice(currentIndex, currentIndex + 200)
                      .map((e, i) => (
                        <tr
                          key={e.id}
                          style={{
                            cursor: "move",
                            opacity: isReordering ? 0.5 : 1,
                            pointerEvents: isReordering ? "none" : "auto",
                          }}
                        >
                          <th scope="row">
                            {isReordering ? (
                              <Spinner size="sm" />
                            ) : !isDirty ? (
                              e.order
                            ) : (
                              ++i
                            )}
                          </th>
                          <td>{e.description}</td>
                          <td>{e.nameExhibition}</td>
                          <td>{e.isVisible ? "Sim" : "Não"}</td>
                          <td>{e.isDefault ? "Sim" : "Não"}</td>
                          <td>
                            <i
                              className="mdi mdi-pencil"
                              style={{
                                color: "green",
                                fontSize: 17,
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setEditMenu(e);
                                setModalEditMenu(true);
                              }}
                            />{" "}
                            {!e.isDefault ? (
                              <DeleteButton
                                onClick={() => {
                                  setDeleteButtonData(e);
                                  setConfirmAlert(true);
                                }}
                              />
                            ) : (
                              <></>
                            )}
                          </td>
                        </tr>
                      ))
                  )}
                </tbody>
              </Table>
            </ReactDragListView>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(Menu);
